var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(_vm.open ? 'accordion open ' : 'accordion ') + _vm.layout},[_c('div',{staticClass:"header",on:{"click":_vm.toggle}},[_vm._t("header")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],staticClass:"body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }